export class CourseDetail {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.code = data.code;
    this.totalQuizzes = data.totalQuizzes;
    this.ansiApproved = data.ansiApproved;
    this.certificateId = data.certificateId;
    this.active = data.active;
    this.createdDate = data.createdDate;
    this.editedDate = data.editedDate;
  }

  /**
   * Map to readable
   * @param {CourseDetail} courseDetail Course detail.
   * @returns {string}
   */
  static toReadable(courseDetail) {
    return courseDetail.name;
  }
}
